module.exports = __webpack_public_path__ + "static/media/threshold.85280e51.png";